export default __webpack_public_path__ + "static/level-up-ab2e34af6086758805268c4269d0cb39.jpg";